<app-leveltwo [pageName]="'General Info'">
<div class="General">
  <h3>{{'NavMenu.Proptax'|translate}}</h3>
  <div class="Imgcontainer">
    <img src="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1642180869/Images/PropertyTaxSystemFLAT_20220114.svg" alt="Property Tax System" usemap="#image-map">
    <a href="https://www.lavote.net/" target="_blank"><div class="rectangle-RR"></div></a>
    <a href="https://lacaab.lacounty.gov/Home.aspx" target="_blank"><div class="rectangle-AABS"></div></a>
    <a href="https://auditor.lacounty.gov/" target="_blank"><div class="rectangle-AC1"></div></a>
    <a href="https://ttc.lacounty.gov/" target="_blank"><div class="rectangle-TTC"></div></a>
    <a href="https://auditor.lacounty.gov/" target="_blank"><div class="rectangle-AC2"></div></a>
    <!--<map name="image-map">
    <area target="_blank" alt="Registrar Recorder" title="Registrar Recorder" href="https://www.lavote.net/" coords="14,182,800,600" shape="rect">
    <area target="_blank" alt="Assessment Appeals Board" title="Assessment Appeals Board" href="http://bos.lacounty.gov/" coords="13,182,475,376" shape="rect">
    <area target="_blank" alt="Auditor-Controller" title="Auditor-Controller" href="https://auditor.lacounty.gov/" coords="13,388,159,611" shape="rect">
    <area target="_blank" alt="Treasurer and Tax Collector" title="Treasurer and Tax Collector" href="https://ttc.lacounty.gov/" coords="172,391,319,606" shape="rect">
    <area target="_blank" alt="Auditor-Controller2" title="Auditor-Controller2" href="https://auditor.lacounty.gov/" coords="330,387,479,608" shape="rect">
</map>-->
  </div>



</div>
<app-leveltwo>
